var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousfaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 28.6,
    height: 28.6,
    rx: 4.3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2201_1873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5232 14.1659L15.9932 9.69591L14.8148 8.51758L8.33317 14.9992L14.8148 21.4809L15.9932 20.3026L11.5232 15.8326H21.6665V14.1659H11.5232Z",
    fill: "#002841"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 28.6,
    height: 28.6,
    rx: 4.3,
    stroke: "#CECECD",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2201_1873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousfaded);
export default __webpack_public_path__ + "static/media/previousfaded.3f3130f0.svg";
export { ForwardRef as ReactComponent };